import { render, staticRenderFns } from "./PrineButton.vue?vue&type=template&id=61103942&scoped=true&"
import script from "./PrineButton.vue?vue&type=script&lang=ts&"
export * from "./PrineButton.vue?vue&type=script&lang=ts&"
import style0 from "./PrineButton.vue?vue&type=style&index=0&id=61103942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61103942",
  null
  
)

export default component.exports